import React from "react";
import { RouteComponentProps } from "react-router";
import { useCollaboratorsQuery } from "../../../query/payments/queries";
import { WSQueries } from "../../../query/WSQuery";
import { PayableForm } from "../../components/PayableForm/PayableForm";

export const CreatePayable: React.FC<RouteComponentProps<
  any,
  any,
  { collaboratorId?: string; backPath?: string }
>> = ({ location }) => {
  const collaboratorId = location.state?.collaboratorId;
  const collaboratorsQuery = useCollaboratorsQuery();
  const backPath = location.state?.backPath;

  return (
    <WSQueries queries={{ collaboratorsQuery }}>
      {({ collaboratorsQuery: { data: collaborators } }) => {
        const collaborator = collaborators.find(
          c => c.collaboratorId === collaboratorId
        );

        return <PayableForm backPath={backPath} collaborator={collaborator} />;
      }}
    </WSQueries>
  );
};
